import React, { useState } from 'react';
import { IonContent,  IonPage, useIonRouter } from "@ionic/react"
import './Profile.css';

import HeaderComponent from '../../../components/HeaderComponent';
import { StatCard } from '../../../components/StatCard';
const Profile:React.FC=()=>{
  const router = useIonRouter();
const data = {
    ordersToday: { count: 12, amount: 1540 },
    ordersYesterday: { count: 9, amount: 1210 },
    tipsToday: { amount: 180 },
    tipsYesterday: { amount: 95 },
  };
  return (
    <IonPage>
      <HeaderComponent/>
      <IonContent className="bg-slate-100">
        <div className="p-4">
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        <StatCard
          title="Заказов за сегодня"
          subtitle="Количество и сумма"
          count={data.ordersToday.count}
          amount={data.ordersToday.amount}
        />

        <StatCard
          title="Заказов за вчера"
          subtitle="Количество и сумма"
          count={data.ordersYesterday.count}
          amount={data.ordersYesterday.amount}
        />

        <StatCard
          title="Чаевых сегодня"
          subtitle="Сумма"
          // count не нужен — можно оставить пустым
          amount={data.tipsToday.amount}
        />

        <StatCard
          title="Чаевых вчера"
          subtitle="Сумма"
          amount={data.tipsYesterday.amount}
        />
      </div>
    </div>
{/* 
        <div className="mx-auto max-w-md px-3 pb-28 pt-3 flex flex-col gap-4">
          <div className="grid grid-cols-2 gap-3">
            <CardStat value="12" label="Заказов" color="bg-blue-50 text-blue-600 border-blue-200" />
            <CardStat value="4,250" label="TJS общая сумма" color="bg-green-50 text-green-600 border-green-200" />
            <CardStat value="320" label="TJS чаевые" color="bg-orange-50 text-orange-600 border-orange-200" />
            <CardStat value="8.5" label="Средний рейтинг" color="bg-purple-50 text-purple-600 border-purple-200" />
          </div>

          <Section title="Типы заказов">
            <OrderType iconColor="bg-green-500" label="Выполнено" value="9 заказов" />
            <OrderType iconColor="bg-orange-500" label="В процессе" value="2 заказа" />
            <OrderType iconColor="bg-red-500" label="Отменено" value="1 заказ" />
          </Section> */}

          {/* <Section title="Настройки чаевых">
            <div className="rounded-xl bg-blue-50 border border-blue-200 flex flex-col gap-1 p-3">
              <span className="text-sm font-medium flex items-center gap-1">
                💳 Dcity Кошелек
              </span>
              <span className="text-xs text-slate-600">+992 90 123 4567</span>
            </div>
            <button className="mt-2 w-full rounded-xl bg-slate-100 py-2 text-sm text-slate-600 font-medium">
              Изменить кошелек
            </button>
          </Section> */}

          {/* <Section title="Цель накоплений">
            <div className="rounded-xl bg-gradient-to-r from-purple-50 to-pink-50 border border-purple-200 p-3">
              <span className="font-medium text-sm flex items-center gap-1 text-purple-700">
                🎓 Обучение в университете
              </span>
              <p className="text-xs mt-1 text-slate-600">
                Накоплено: 2,840 TJS из 15,000 TJS
              </p>

              <div className="w-full h-2 bg-purple-100 rounded-full mt-2">
                <div
                  className="h-2 bg-purple-500 rounded-full"
                  style={{ width: "19%" }} 
                ></div>
              </div>
            </div>

            <button className="mt-3 w-full rounded-xl bg-purple-500 py-2 text-sm text-white font-medium">
              Изменить цель
            </button>
          </Section> */}

        {/* </div> */}
      </IonContent>
    </IonPage>
  );
}
const CardStat = ({
  value,
  label,
  color,
}: {
  value: string;
  label: string;
  color?: string;
}) => (
  <div
    className={`rounded-xl border p-3 shadow-sm flex flex-col justify-center ${color}`}
  >
    <div className="text-lg font-bold">{value}</div>
    <div className="text-xs">{label}</div>
  </div>
);

const Section = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <div className="rounded-2xl bg-white shadow-sm p-4">
    <h3 className="text-sm font-semibold mb-3">{title}</h3>
    {children}
  </div>
);

const OrderType = ({
  iconColor,
  label,
  value,
}: {
  iconColor: string;
  label: string;
  value: string;
}) => (
  <div className="flex justify-between items-center text-sm mb-2">
    <div className="flex items-center gap-2">
      <span className={`h-2 w-2 rounded-full ${iconColor}`} />
      <span>{label}</span>
    </div>
    <span className="text-slate-600">{value}</span>
  </div>
);
export default Profile